
import Logout1 from "../../../assets/duotone/Logout1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Logout1Icon({ className, dataTestid = "Logout1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Logout1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
